module.exports = __webpack_public_path__ + "static/media/img_give_back@2x.b7184ef7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_give_back@2x.webp
// module id = 815
// module chunks = 0